import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import me from "./modules/me"
import charts from "./modules/charts"
import encounters from "./modules/encounters"
import sidebar from "./modules/sidebar"
import labOrders from "./modules/lab-orders"
import occupationalHealthRecords from "./modules/occupational-health-records"
import subordinateProviders from "./modules/subordinate_providers"

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    me,
    charts,
    encounters,
    sidebar,
    labOrders,
    occupationalHealthRecords,
    subordinateProviders
  }
})

export default store
export const useStore = () => store
